/**
 * `localStorage` key for the cross-tab "this document window is already open"
 * lock, scoped per document (OR-22558: one window per document). Each
 * document window writes `{ tabId, timestamp }` here under its own key on
 * mount and clears it on unload, so `openDocumentViewerWindow` can avoid
 * spawning a duplicate window for the same document from a different Review
 * tab. Named-window targeting (`window.open` with the same name) already
 * refocuses an existing window in most browsers; this lock is a defensive
 * backstop for browsers/contexts where that doesn't reliably happen.
 * @param {string} appId - The approval / application id the document belongs to.
 * @param {string} documentId - The document id.
 * @returns {string} The `localStorage` key for this document's opener lock.
 */
export function getOpenerLockKey(appId: string, documentId: string): string {
  return `dsc-doc-viewer-opener:${appId}:${documentId}`;
}
